import { StateCreator } from 'zustand';

import { Store } from 'store';

export type SelectedItemInfo = {
  id: number;
  title: string;
};

export interface SellApartmentSlice {
  sellApartmentSearch: string;
  setSellApartmentSearch: (value: string) => void;

  selectedSellComplex: SelectedItemInfo;
  setSelectedSellComplex: (complex: SelectedItemInfo | null) => void;

  selectedSellBuilding: SelectedItemInfo;
  setSelectedSellBuilding: (building: SelectedItemInfo) => void;

  sellApartmentNumber: string;
  setSellApartmentNumber: (number: string) => void;

  resetSellFlow: () => void;
}

const createSellApartmentSlice: StateCreator<
  Store,
  [['zustand/immer', never]],
  [],
  SellApartmentSlice
> = (set) => ({
  sellApartmentSearch: '',
  setSellApartmentSearch: (value) => set({ sellApartmentSearch: value }),

  selectedSellComplex: {
    id: -1,
    title: '',
  },
  setSelectedSellComplex: (complex) =>
    set({ selectedSellComplex: complex ?? { id: -1, title: '' } }),

  selectedSellBuilding: {
    id: -1,
    title: '',
  },
  setSelectedSellBuilding: (building) => set({ selectedSellBuilding: building }),

  sellApartmentNumber: '',
  setSellApartmentNumber: (number) => set({ sellApartmentNumber: number }),

  resetSellFlow: () =>
    set({
      sellApartmentSearch: '',
      selectedSellComplex: { id: -1, title: '' },
      selectedSellBuilding: {
        id: -1,
        title: '',
      },
      sellApartmentNumber: '',
    }),
});

export default createSellApartmentSlice;
